import React from "react";

const VALUES = [
  {
    id: "clarity",
    title: "Clarity First",
    desc:
      "We surface answers, not noise. Every response is grounded in verified context, reducing friction and elevating decision quality.",
  },
  {
    id: "privacy",
    title: "Privacy Always",
    desc:
      "Your data remains yours – encrypted, isolated, and never used for model training. Security isn't a feature; it's the foundation.",
  },
  {
    id: "workflows",
    title: "Built for Enterprise Workflows",
    desc:
      "Highwatch is engineered for regulated environments, from healthcare to finance, enabling high-stakes teams to work with confidence.",
  },
  {
    id: "evolves",
    title: "Evolves with Your Organization",
    desc:
      "Every deployment learns securely within your ecosystem, adapting to your systems, permissions, and compliance requirements.",
  },
];

export default function ValuesSection() {
  return (
    <section className="about-values">
      <div className="about-values__inner">
        <div className="about-values__header">
          <div className="about-values__pill">VALUES</div>
          <h2>Designed for trust, built for clarity.</h2>
          <p>
            Every Highwatch interaction is designed around precision, context, and compliance. From
            how data is retrieved to how insights are presented, our focus is on clarity, control,
            and measurable enterprise impact.
          </p>
        </div>
        <div className="about-values__grid">
          {VALUES.map((item) => (
            <article
              key={item.id}
              className={`about-values__card about-values__card--${item.id}`}
            >
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
